import * as v from "valibot"

export type CountryDataEntries = {
    countryName: string
    alpha2Code: string
    alpha3Code: string
    numericCode: number
    iso3166Link: string
    independent: boolean
    commonNames: string
}

export type CountryCommonNamesAndCode = Pick<
    CountryDataEntries,
    "commonNames" | "alpha2Code"
>

export const countryData: CountryDataEntries[] = [
    {
        countryName: "Afghanistan",
        alpha2Code: "AF",
        alpha3Code: "AFG",
        numericCode: 4.0,
        iso3166Link: "ISO 3166-2:AF",
        independent: true,
        commonNames: `Afghanistan, Afghanistan, AF`
    },
    {
        countryName: "Åland Islands",
        alpha2Code: "AX",
        alpha3Code: "ALA",
        numericCode: 248.0,
        iso3166Link: "ISO 3166-2:AX",
        independent: false,
        commonNames: `Åland Islands, Aland Islands, Ahvenanmaa, Aaland, Ahvenanmaa provinces`
    },
    {
        countryName: "Albania",
        alpha2Code: "AL",
        alpha3Code: "ALB",
        numericCode: 8.0,
        iso3166Link: "ISO 3166-2:AL",
        independent: true,
        commonNames: `Albania, Shqipëri, Shqipëria, Shqipni, Shqiperi, Shqiperia`
    },
    {
        countryName: "Algeria",
        alpha2Code: "DZ",
        alpha3Code: "DZA",
        numericCode: 12.0,
        iso3166Link: "ISO 3166-2:DZ",
        independent: true,
        commonNames: `Algeria, Algiers, People's Democratic Republic of Algeria, Algérie`
    },
    {
        countryName: "American Samoa",
        alpha2Code: "AS",
        alpha3Code: "ASM",
        numericCode: 16.0,
        iso3166Link: "ISO 3166-2:AS",
        independent: false,
        commonNames: `American Samoa, AS, Samoa Americana`
    },
    {
        countryName: "Andorra",
        alpha2Code: "AD",
        alpha3Code: "AND",
        numericCode: 20.0,
        iso3166Link: "ISO 3166-2:AD",
        independent: true,
        commonNames: `Principality of Andorra, Andorra la Vella, Andorra, Pyrénées`
    },
    {
        countryName: "Angola",
        alpha2Code: "AO",
        alpha3Code: "AGO",
        numericCode: 24.0,
        iso3166Link: "ISO 3166-2:AO",
        independent: true,
        commonNames: `Angola, Republic of Angola`
    },
    {
        countryName: "Anguilla",
        alpha2Code: "AI",
        alpha3Code: "AIA",
        numericCode: 660.0,
        iso3166Link: "ISO 3166-2:AI",
        independent: false,
        commonNames: `Anguilla`
    },
    {
        countryName: "Antarctica",
        alpha2Code: "AQ",
        alpha3Code: "ATA",
        numericCode: 10.0,
        iso3166Link: "ISO 3166-2:AQ",
        independent: false,
        commonNames: `Antarctica, South Pole, Southern Continent`
    },
    {
        countryName: "Antigua and Barbuda",
        alpha2Code: "AG",
        alpha3Code: "ATG",
        numericCode: 28.0,
        iso3166Link: "ISO 3166-2:AG",
        independent: true,
        commonNames: `Antigua and Barbuda, West Indies, Wadadli, Twin island state`
    },
    {
        countryName: "Argentina",
        alpha2Code: "AR",
        alpha3Code: "ARG",
        numericCode: 32.0,
        iso3166Link: "ISO 3166-2:AR",
        independent: true,
        commonNames: `Argentina, Argentine Republic`
    },
    {
        countryName: "Armenia",
        alpha2Code: "AM",
        alpha3Code: "ARM",
        numericCode: 51.0,
        iso3166Link: "ISO 3166-2:AM",
        independent: true,
        commonNames: `Armenia, Hayastan, Republic of Armenia`
    },
    {
        countryName: "Aruba",
        alpha2Code: "AW",
        alpha3Code: "ABW",
        numericCode: 533.0,
        iso3166Link: "ISO 3166-2:AW",
        independent: false,
        commonNames: `Aruba, Dutch Antilles, The Happy Island`
    },
    {
        countryName: "Australia",
        alpha2Code: "AU",
        alpha3Code: "AUS",
        numericCode: 36.0,
        iso3166Link: "ISO 3166-2:AU",
        independent: true,
        commonNames: `Australia, Down Under, Oz`
    },
    {
        countryName: "Austria",
        alpha2Code: "AT",
        alpha3Code: "AUT",
        numericCode: 40.0,
        iso3166Link: "ISO 3166-2:AT",
        independent: true,
        commonNames: `Austria, Österreich`
    },
    {
        countryName: "Azerbaijan",
        alpha2Code: "AZ",
        alpha3Code: "AZE",
        numericCode: 31.0,
        iso3166Link: "ISO 3166-2:AZ",
        independent: true,
        commonNames: `Azerbaijan, Azarbaycan`
    },
    {
        countryName: "Bahamas",
        alpha2Code: "BS",
        alpha3Code: "BHS",
        numericCode: 44.0,
        iso3166Link: "ISO 3166-2:BS",
        independent: true,
        commonNames: `The Bahamas, Commonwealth of the Bahamas`
    },
    {
        countryName: "Bahrain",
        alpha2Code: "BH",
        alpha3Code: "BHR",
        numericCode: 48.0,
        iso3166Link: "ISO 3166-2:BH",
        independent: true,
        commonNames: `Bahrain, Kingdom of Bahrain`
    },
    {
        countryName: "Bangladesh",
        alpha2Code: "BD",
        alpha3Code: "BGD",
        numericCode: 50.0,
        iso3166Link: "ISO 3166-2:BD",
        independent: true,
        commonNames: `Bengal, People's Republic of Bangladesh, East Pakistan`
    },
    {
        countryName: "Barbados",
        alpha2Code: "BB",
        alpha3Code: "BRB",
        numericCode: 52.0,
        iso3166Link: "ISO 3166-2:BB",
        independent: true,
        commonNames: `Barbados, Little England, Bim, Barbados Island`
    },
    {
        countryName: "Belarus",
        alpha2Code: "BY",
        alpha3Code: "BLR",
        numericCode: 112.0,
        iso3166Link: "ISO 3166-2:BY",
        independent: false,
        commonNames: `Belarus, Byelorussia, White Russia`
    },
    {
        countryName: "Belgium",
        alpha2Code: "BE",
        alpha3Code: "BEL",
        numericCode: 56.0,
        iso3166Link: "ISO 3166-2:BE",
        independent: true,
        commonNames: `Belgium, Kingdom of Belgium, Belgian, Belgique`
    },
    {
        countryName: "Belize",
        alpha2Code: "BZ",
        alpha3Code: "BLZ",
        numericCode: 84.0,
        iso3166Link: "ISO 3166-2:BZ",
        independent: true,
        commonNames: `Belize, British Honduras`
    },
    {
        countryName: "Benin",
        alpha2Code: "BJ",
        alpha3Code: "BEN",
        numericCode: 204.0,
        iso3166Link: "ISO 3166-2:BJ",
        independent: true,
        commonNames: `Benin, Dahomey`
    },
    {
        countryName: "Bermuda",
        alpha2Code: "BM",
        alpha3Code: "BMU",
        numericCode: 60.0,
        iso3166Link: "ISO 3166-2:BM",
        independent: false,
        commonNames: `Bermuda, The Bermudas, Somers Isles, The Rock`
    },
    {
        countryName: "Bhutan",
        alpha2Code: "BT",
        alpha3Code: "BTN",
        numericCode: 64.0,
        iso3166Link: "ISO 3166-2:BT",
        independent: true,
        commonNames: `Bhutan, Land of the Thunder Dragon`
    },
    {
        countryName: "Bolivia (Plurinational State of)",
        alpha2Code: "BO",
        alpha3Code: "BOL",
        numericCode: 68.0,
        iso3166Link: "ISO 3166-2:BO",
        independent: true,
        commonNames: `Bolivia (Plurinational State of), Bolivia, Plurinational State of,`
    },
    {
        countryName: "Bonaire, Sint Eustatius and Saba",
        alpha2Code: "BQ",
        alpha3Code: "BES",
        numericCode: 535.0,
        iso3166Link: "ISO 3166-2:BQ",
        independent: false,
        commonNames: `Bonaire, Sint Eustatius and Saba, Caribbean Netherlands, BES Islands, Bonaire Sint Eustatius And Saba`
    },
    {
        countryName: "Bosnia and Herzegovina",
        alpha2Code: "BA",
        alpha3Code: "BIH",
        numericCode: 70.0,
        iso3166Link: "ISO 3166-2:BA",
        independent: true,
        commonNames: `Bosnia and Herzegovina, Bosnia, Herzegovina, BiH, Bosnia Herzegovina`
    },
    {
        countryName: "Botswana",
        alpha2Code: "BW",
        alpha3Code: "BWA",
        numericCode: 72.0,
        iso3166Link: "ISO 3166-2:BW",
        independent: true,
        commonNames: `Botswana, Botsuana, Republic of Botswana`
    },
    {
        countryName: "Bouvet Island",
        alpha2Code: "BV",
        alpha3Code: "BVT",
        numericCode: 74.0,
        iso3166Link: "ISO 3166-2:BV",
        independent: false,
        commonNames: `Bouvet Island`
    },
    {
        countryName: "Brazil",
        alpha2Code: "BR",
        alpha3Code: "BRA",
        numericCode: 76.0,
        iso3166Link: "ISO 3166-2:BR",
        independent: true,
        commonNames: `Brazil, Brasilia, Federative Republic of Brazil`
    },
    {
        countryName: "British Indian Ocean Territory",
        alpha2Code: "IO",
        alpha3Code: "IOT",
        numericCode: 86.0,
        iso3166Link: "ISO 3166-2:IO",
        independent: false,
        commonNames: `British Indian Ocean Territory, BIOT, Chagos Islands, Diego Garcia`
    },
    {
        countryName: "Brunei Darussalam",
        alpha2Code: "BN",
        alpha3Code: "BRN",
        numericCode: 96.0,
        iso3166Link: "ISO 3166-2:BN",
        independent: true,
        commonNames: `Brunei Darussalam, Brunei, Brunei Bay, State of Brunei, Abode of Peace`
    },
    {
        countryName: "Bulgaria",
        alpha2Code: "BG",
        alpha3Code: "BGR",
        numericCode: 100.0,
        iso3166Link: "ISO 3166-2:BG",
        independent: true,
        commonNames: `Bulgaria, Republic of Bulgaria`
    },
    {
        countryName: "Burkina Faso",
        alpha2Code: "BF",
        alpha3Code: "BFA",
        numericCode: 854.0,
        iso3166Link: "ISO 3166-2:BF",
        independent: true,
        commonNames: `Burkina Faso, Upper Volta`
    },
    {
        countryName: "Burundi",
        alpha2Code: "BI",
        alpha3Code: "BDI",
        numericCode: 108.0,
        iso3166Link: "ISO 3166-2:BI",
        independent: true,
        commonNames: `Burundi, The Republic of Burundi, Heart of Africa`
    },
    {
        countryName: "Cabo Verde",
        alpha2Code: "CV",
        alpha3Code: "CPV",
        numericCode: 132.0,
        iso3166Link: "ISO 3166-2:CV",
        independent: true,
        commonNames: `Cape Verde, Republic of Cabo Verde, Republic of Cape Verde`
    },
    {
        countryName: "Cambodia",
        alpha2Code: "KH",
        alpha3Code: "KHM",
        numericCode: 116.0,
        iso3166Link: "ISO 3166-2:KH",
        independent: true,
        commonNames: `Cambodia, Kampuchea`
    },
    {
        countryName: "Cameroon",
        alpha2Code: "CM",
        alpha3Code: "CMR",
        numericCode: 120.0,
        iso3166Link: "ISO 3166-2:CM",
        independent: true,
        commonNames: `Cameroon, Cameroun`
    },
    {
        countryName: "Canada",
        alpha2Code: "CA",
        alpha3Code: "CAN",
        numericCode: 124.0,
        iso3166Link: "ISO 3166-2:CA",
        independent: true,
        commonNames: `Canada, Dominion of Canada`
    },
    {
        countryName: "Cayman Islands",
        alpha2Code: "KY",
        alpha3Code: "CYM",
        numericCode: 136.0,
        iso3166Link: "ISO 3166-2:KY",
        independent: false,
        commonNames: `Cayman Islands, none`
    },
    {
        countryName: "Central African Republic",
        alpha2Code: "CF",
        alpha3Code: "CAF",
        numericCode: 140.0,
        iso3166Link: "ISO 3166-2:CF",
        independent: true,
        commonNames: `Central African Republic, CAR, C.A.R., Land of the Central Africans, République centrafricaine`
    },
    {
        countryName: "Chad",
        alpha2Code: "TD",
        alpha3Code: "TCD",
        numericCode: 148.0,
        iso3166Link: "ISO 3166-2:TD",
        independent: true,
        commonNames: `Chad`
    },
    {
        countryName: "Chile",
        alpha2Code: "CL",
        alpha3Code: "CHL",
        numericCode: 152.0,
        iso3166Link: "ISO 3166-2:CL",
        independent: true,
        commonNames: `Chile, Republic of Chile, Chilean Republic, Chilean Nation`
    },
    {
        countryName: "China",
        alpha2Code: "CN",
        alpha3Code: "CHN",
        numericCode: 156.0,
        iso3166Link: "ISO 3166-2:CN",
        independent: true,
        commonNames: `China, China, People's Republic of China`
    },
    {
        countryName: "Christmas Island",
        alpha2Code: "CX",
        alpha3Code: "CXR",
        numericCode: 162.0,
        iso3166Link: "ISO 3166-2:CX",
        independent: false,
        commonNames: `Territory of Christmas Island, CX, CXI`
    },
    {
        countryName: "Cocos (Keeling) Islands",
        alpha2Code: "CC",
        alpha3Code: "CCK",
        numericCode: 166.0,
        iso3166Link: "ISO 3166-2:CC",
        independent: false,
        commonNames: `Cocos (Keeling) Islands, Cocos Islands, Keeling Islands`
    },
    {
        countryName: "Colombia",
        alpha2Code: "CO",
        alpha3Code: "COL",
        numericCode: 170.0,
        iso3166Link: "ISO 3166-2:CO",
        independent: true,
        commonNames: `Colombia, Republic of Colombia, Colombian Republic`
    },
    {
        countryName: "Comoros",
        alpha2Code: "KM",
        alpha3Code: "COM",
        numericCode: 174.0,
        iso3166Link: "ISO 3166-2:KM",
        independent: true,
        commonNames: `Comoros, Union of the Comoros`
    },
    {
        countryName: "Congo",
        alpha2Code: "CG",
        alpha3Code: "COG",
        numericCode: 178.0,
        iso3166Link: "ISO 3166-2:CG",
        independent: true,
        commonNames: `Republic of the Congo, Congo-Brazzaville, Congo Republic, French Congo`
    },
    {
        countryName: "Congo, Democratic Republic of the",
        alpha2Code: "CD",
        alpha3Code: "COD",
        numericCode: 180.0,
        iso3166Link: "ISO 3166-2:CD",
        independent: true,
        commonNames: `Congo, Democratic Republic of the, Congo, DR Congo, DRC`
    },
    {
        countryName: "Cook Islands",
        alpha2Code: "CK",
        alpha3Code: "COK",
        numericCode: 184.0,
        iso3166Link: "ISO 3166-2:CK",
        independent: false,
        commonNames: `Cook Islands, Rarotonga, Avarua`
    },
    {
        countryName: "Costa Rica",
        alpha2Code: "CR",
        alpha3Code: "CRI",
        numericCode: 188.0,
        iso3166Link: "ISO 3166-2:CR",
        independent: true,
        commonNames: `Costa Rica, Rica, CR`
    },
    {
        countryName: "Côte d'Ivoire",
        alpha2Code: "CI",
        alpha3Code: "CIV",
        numericCode: 384.0,
        iso3166Link: "ISO 3166-2:CI",
        independent: true,
        commonNames: `Côte d'Ivoire, Ivory Coast`
    },
    {
        countryName: "Croatia",
        alpha2Code: "HR",
        alpha3Code: "HRV",
        numericCode: 191.0,
        iso3166Link: "ISO 3166-2:HR",
        independent: true,
        commonNames: `Croatia, Hrvatska, Republika Hrvatska`
    },
    {
        countryName: "Cuba",
        alpha2Code: "CU",
        alpha3Code: "CUB",
        numericCode: 192.0,
        iso3166Link: "ISO 3166-2:CU",
        independent: true,
        commonNames: `Cuba,Cuban Republic,Republic of Cuba,Isle of Youth`
    },
    {
        countryName: "Curaçao",
        alpha2Code: "CW",
        alpha3Code: "CUW",
        numericCode: 531.0,
        iso3166Link: "ISO 3166-2:CW",
        independent: false,
        commonNames: `Curaçao, Curacao,Grenada,Kiribati,Seychelles`
    },
    {
        countryName: "Cyprus",
        alpha2Code: "CY",
        alpha3Code: "CYP",
        numericCode: 196.0,
        iso3166Link: "ISO 3166-2:CY",
        independent: true,
        commonNames: `Cyprus, Cyprus, Kıbrıs, Republic of Cyprus`
    },
    {
        countryName: "Czechia",
        alpha2Code: "CZ",
        alpha3Code: "CZE",
        numericCode: 203.0,
        iso3166Link: "ISO 3166-2:CZ",
        independent: true,
        commonNames: `Czechia, Czech Republic, Czechoslovakia`
    },
    {
        countryName: "Denmark",
        alpha2Code: "DK",
        alpha3Code: "DNK",
        numericCode: 208.0,
        iso3166Link: "ISO 3166-2:DK",
        independent: true,
        commonNames: `Denmark, Danmark`
    },
    {
        countryName: "Djibouti",
        alpha2Code: "DJ",
        alpha3Code: "DJI",
        numericCode: 262.0,
        iso3166Link: "ISO 3166-2:DJ",
        independent: true,
        commonNames: `Djibouti, Jibuti`
    },
    {
        countryName: "Dominica",
        alpha2Code: "DM",
        alpha3Code: "DMA",
        numericCode: 212.0,
        iso3166Link: "ISO 3166-2:DM",
        independent: true,
        commonNames: `Dominica, Commonwealth of Dominica, Nature Isle of the Caribbean`
    },
    {
        countryName: "Dominican Republic",
        alpha2Code: "DO",
        alpha3Code: "DOM",
        numericCode: 214.0,
        iso3166Link: "ISO 3166-2:DO",
        independent: true,
        commonNames: `Dominican Republic, DR, Santo Domingo, Hispaniola, Quisqueya`
    },
    {
        countryName: "Ecuador",
        alpha2Code: "EC",
        alpha3Code: "ECU",
        numericCode: 218.0,
        iso3166Link: "ISO 3166-2:EC",
        independent: true,
        commonNames: `Ecuador, Republic of Ecuador`
    },
    {
        countryName: "Egypt",
        alpha2Code: "EG",
        alpha3Code: "EGY",
        numericCode: 818.0,
        iso3166Link: "ISO 3166-2:EG",
        independent: true,
        commonNames: `Egypt, Arab Republic of Egypt, Misr`
    },
    {
        countryName: "El Salvador",
        alpha2Code: "SV",
        alpha3Code: "SLV",
        numericCode: 222.0,
        iso3166Link: "ISO 3166-2:SV",
        independent: true,
        commonNames: `El Salvador, Salvador, Cuscatlán`
    },
    {
        countryName: "Equatorial Guinea",
        alpha2Code: "GQ",
        alpha3Code: "GNQ",
        numericCode: 226.0,
        iso3166Link: "ISO 3166-2:GQ",
        independent: true,
        commonNames: `Equatorial Guinea, Guinea Ecuatorial, E.G., EQG`
    },
    {
        countryName: "Eritrea",
        alpha2Code: "ER",
        alpha3Code: "ERI",
        numericCode: 232.0,
        iso3166Link: "ISO 3166-2:ER",
        independent: true,
        commonNames: `Eritrea, State of Eritrea, Erythraea, Red Sea State`
    },
    {
        countryName: "Estonia",
        alpha2Code: "EE",
        alpha3Code: "EST",
        numericCode: 233.0,
        iso3166Link: "ISO 3166-2:EE",
        independent: true,
        commonNames: `Estonia, Eesti`
    },
    {
        countryName: "Eswatini",
        alpha2Code: "SZ",
        alpha3Code: "SWZ",
        numericCode: 748.0,
        iso3166Link: "ISO 3166-2:SZ",
        independent: true,
        commonNames: `Eswatini, Swaziland, Ngwane, Swati, 			Prince Edward Island`
    },
    {
        countryName: "Ethiopia",
        alpha2Code: "ET",
        alpha3Code: "ETH",
        numericCode: 231.0,
        iso3166Link: "ISO 3166-2:ET",
        independent: true,
        commonNames: `Ethiopia, Abiyotiyopia, Ityopiya, Abyssinia`
    },
    {
        countryName: "Falkland Islands (Malvinas)",
        alpha2Code: "FK",
        alpha3Code: "FLK",
        numericCode: 238.0,
        iso3166Link: "ISO 3166-2:FK",
        independent: false,
        commonNames: `Falkland Islands (Malvinas), Falkland Islands, Malvinas`
    },
    {
        countryName: "Faroe Islands",
        alpha2Code: "FO",
        alpha3Code: "FRO",
        numericCode: 234.0,
        iso3166Link: "ISO 3166-2:FO",
        independent: false,
        commonNames: `Faroe Islands, Faeroe Islands, Føroyar`
    },
    {
        countryName: "Fiji",
        alpha2Code: "FJ",
        alpha3Code: "FJI",
        numericCode: 242.0,
        iso3166Link: "ISO 3166-2:FJ",
        independent: true,
        commonNames: `Fiji, Republic of Fiji, Viti, Viti Levu`
    },
    {
        countryName: "Finland",
        alpha2Code: "FI",
        alpha3Code: "FIN",
        numericCode: 246.0,
        iso3166Link: "ISO 3166-2:FI",
        independent: true,
        commonNames: `Finland, Suomi`
    },
    {
        countryName: "France",
        alpha2Code: "FR",
        alpha3Code: "FRA",
        numericCode: 250.0,
        iso3166Link: "ISO 3166-2:FR",
        independent: true,
        commonNames: `France, French Republic`
    },
    {
        countryName: "French Guiana",
        alpha2Code: "GF",
        alpha3Code: "GUF",
        numericCode: 254.0,
        iso3166Link: "ISO 3166-2:GF",
        independent: false,
        commonNames: `French Guiana, Guiana, Guyane, France in South America`
    },
    {
        countryName: "French Polynesia",
        alpha2Code: "PF",
        alpha3Code: "PYF",
        numericCode: 258.0,
        iso3166Link: "ISO 3166-2:PF",
        independent: false,
        commonNames: `French Polynesia, Tahiti, Society Islands, Windward Islands`
    },
    {
        countryName: "French Southern Territories",
        alpha2Code: "TF",
        alpha3Code: "ATF",
        numericCode: 260.0,
        iso3166Link: "ISO 3166-2:TF",
        independent: false,
        commonNames: `French Southern Territories, Terres australes françaises`
    },
    {
        countryName: "Gabon",
        alpha2Code: "GA",
        alpha3Code: "GAB",
        numericCode: 266.0,
        iso3166Link: "ISO 3166-2:GA",
        independent: true,
        commonNames: `Gabon, The Gabonese Republic.`
    },
    {
        countryName: "Gambia",
        alpha2Code: "GM",
        alpha3Code: "GMB",
        numericCode: 270.0,
        iso3166Link: "ISO 3166-2:GM",
        independent: true,
        commonNames: `Gambia, The Gambia`
    },
    {
        countryName: "Georgia",
        alpha2Code: "GE",
        alpha3Code: "GEO",
        numericCode: 268.0,
        iso3166Link: "ISO 3166-2:GE",
        independent: true,
        commonNames: `Georgia, Sakartvelo`
    },
    {
        countryName: "Germany",
        alpha2Code: "DE",
        alpha3Code: "DEU",
        numericCode: 276.0,
        iso3166Link: "ISO 3166-2:DE",
        independent: true,
        commonNames: `Germany, Deutschland, Federal Republic of Germany`
    },
    {
        countryName: "Ghana",
        alpha2Code: "GH",
        alpha3Code: "GHA",
        numericCode: 288.0,
        iso3166Link: "ISO 3166-2:GH",
        independent: true,
        commonNames: `Ghana, Gold Coast, West Africa`
    },
    {
        countryName: "Gibraltar",
        alpha2Code: "GI",
        alpha3Code: "GIB",
        numericCode: 292.0,
        iso3166Link: "ISO 3166-2:GI",
        independent: false,
        commonNames: `Gibraltar, The Rock`
    },
    {
        countryName: "Greece",
        alpha2Code: "GR",
        alpha3Code: "GRC",
        numericCode: 300.0,
        iso3166Link: "ISO 3166-2:GR",
        independent: true,
        commonNames: `Greece, Hellenic Republic, Hellas`
    },
    {
        countryName: "Greenland",
        alpha2Code: "GL",
        alpha3Code: "GRL",
        numericCode: 304.0,
        iso3166Link: "ISO 3166-2:GL",
        independent: false,
        commonNames: `Greenland, Kalaallit Nunaat`
    },
    {
        countryName: "Grenada",
        alpha2Code: "GD",
        alpha3Code: "GRD",
        numericCode: 308.0,
        iso3166Link: "ISO 3166-2:GD",
        independent: true,
        commonNames: `Grenada, The Spice Isle`
    },
    {
        countryName: "Guadeloupe",
        alpha2Code: "GP",
        alpha3Code: "GLP",
        numericCode: 312.0,
        iso3166Link: "ISO 3166-2:GP",
        independent: false,
        commonNames: `Guadeloupe, Gwadloup`
    },
    {
        countryName: "Guam",
        alpha2Code: "GU",
        alpha3Code: "GUM",
        numericCode: 316.0,
        iso3166Link: "ISO 3166-2:GU",
        independent: false,
        commonNames: `Guam, America's Gateway to Asia, Island of the Pacific, Tumon Bay, Para Island`
    },
    {
        countryName: "Guatemala",
        alpha2Code: "GT",
        alpha3Code: "GTM",
        numericCode: 320.0,
        iso3166Link: "ISO 3166-2:GT",
        independent: true,
        commonNames: `Guatemala, Guate, Guat, Land of Eternal Spring`
    },
    {
        countryName: "Guernsey",
        alpha2Code: "GG",
        alpha3Code: "GGY",
        numericCode: 831.0,
        iso3166Link: "ISO 3166-2:GG",
        independent: false,
        commonNames: `Channel Islands, Bailiwick of Guernsey, Sark, Alderney`
    },
    {
        countryName: "Guinea",
        alpha2Code: "GN",
        alpha3Code: "GIN",
        numericCode: 324.0,
        iso3166Link: "ISO 3166-2:GN",
        independent: true,
        commonNames: `Guinea, Guinea-Conakry, Republic of Guinea`
    },
    {
        countryName: "Guinea-Bissau",
        alpha2Code: "GW",
        alpha3Code: "GNB",
        numericCode: 624.0,
        iso3166Link: "ISO 3166-2:GW",
        independent: true,
        commonNames: `Guinea-Bissau, Guinea-Bissao, Republic of Guinea-Bissau, Portuguese Guinea`
    },
    {
        countryName: "Guyana",
        alpha2Code: "GY",
        alpha3Code: "GUY",
        numericCode: 328.0,
        iso3166Link: "ISO 3166-2:GY",
        independent: true,
        commonNames: `Guyana, British Guiana`
    },
    {
        countryName: "Haiti",
        alpha2Code: "HT",
        alpha3Code: "HTI",
        numericCode: 332.0,
        iso3166Link: "ISO 3166-2:HT",
        independent: true,
        commonNames: `Haiti, Ayiti`
    },
    {
        countryName: "Heard Island and McDonald Islands",
        alpha2Code: "HM",
        alpha3Code: "HMD",
        numericCode: 334.0,
        iso3166Link: "ISO 3166-2:HM",
        independent: false,
        commonNames: `Heard Island and McDonald Islands, Heard Island, McDonald Islands`
    },
    {
        countryName: "Holy See",
        alpha2Code: "VA",
        alpha3Code: "VAT",
        numericCode: 336.0,
        iso3166Link: "ISO 3166-2:VA",
        independent: true,
        commonNames: `Vatican City, Holy See`
    },
    {
        countryName: "Honduras",
        alpha2Code: "HN",
        alpha3Code: "HND",
        numericCode: 340.0,
        iso3166Link: "ISO 3166-2:HN",
        independent: true,
        commonNames: `Honduras, Republic of Honduras.`
    },
    {
        countryName: "Hong Kong",
        alpha2Code: "HK",
        alpha3Code: "HKG",
        numericCode: 344.0,
        iso3166Link: "ISO 3166-2:HK",
        independent: false,
        commonNames: `Hong Kong, China, Hong Kong SAR`
    },
    {
        countryName: "Hungary",
        alpha2Code: "HU",
        alpha3Code: "HUN",
        numericCode: 348.0,
        iso3166Link: "ISO 3166-2:HU",
        independent: true,
        commonNames: `Hungary, HUN, Magyarország`
    },
    {
        countryName: "Iceland",
        alpha2Code: "IS",
        alpha3Code: "ISL",
        numericCode: 352.0,
        iso3166Link: "ISO 3166-2:IS",
        independent: true,
        commonNames: `Iceland, Island, Republic of Iceland`
    },
    {
        countryName: "India",
        alpha2Code: "IN",
        alpha3Code: "IND",
        numericCode: 356.0,
        iso3166Link: "ISO 3166-2:IN",
        independent: true,
        commonNames: `India, Bharat`
    },
    {
        countryName: "Indonesia",
        alpha2Code: "ID",
        alpha3Code: "IDN",
        numericCode: 360.0,
        iso3166Link: "ISO 3166-2:ID",
        independent: true,
        commonNames: `Indonesia, Indo, East Indies, Nusantara`
    },
    {
        countryName: "Iran (Islamic Republic of)",
        alpha2Code: "IR",
        alpha3Code: "IRN",
        numericCode: 364.0,
        iso3166Link: "ISO 3166-2:IR",
        independent: true,
        commonNames: `Iran (Islamic Republic of), Iran, Persia, Islamic Republic of Iran`
    },
    {
        countryName: "Iraq",
        alpha2Code: "IQ",
        alpha3Code: "IRQ",
        numericCode: 368.0,
        iso3166Link: "ISO 3166-2:IQ",
        independent: true,
        commonNames: `Iraq, Republic of Iraq, Mesopotamia`
    },
    {
        countryName: "Ireland",
        alpha2Code: "IE",
        alpha3Code: "IRL",
        numericCode: 372.0,
        iso3166Link: "ISO 3166-2:IE",
        independent: true,
        commonNames: `Ireland, Eire, Éire, Republic of Ireland`
    },
    {
        countryName: "Isle of Man",
        alpha2Code: "IM",
        alpha3Code: "IMN",
        numericCode: 833.0,
        iso3166Link: "ISO 3166-2:IM",
        independent: false,
        commonNames: `Isle of Man, Manx, Mannin, Ellan Vannin`
    },
    {
        countryName: "Israel",
        alpha2Code: "IL",
        alpha3Code: "ISR",
        numericCode: 376.0,
        iso3166Link: "ISO 3166-2:IL",
        independent: true,
        commonNames: `Israel, Palestine, Holy Land`
    },
    {
        countryName: "Italy",
        alpha2Code: "IT",
        alpha3Code: "ITA",
        numericCode: 380.0,
        iso3166Link: "ISO 3166-2:IT",
        independent: true,
        commonNames: `Italy, Republic of Italy`
    },
    {
        countryName: "Jamaica",
        alpha2Code: "JM",
        alpha3Code: "JAM",
        numericCode: 388.0,
        iso3166Link: "ISO 3166-2:JM",
        independent: true,
        commonNames: `Jamaica, Jamaica, JAM`
    },
    {
        countryName: "Japan",
        alpha2Code: "JP",
        alpha3Code: "JPN",
        numericCode: 392.0,
        iso3166Link: "ISO 3166-2:JP",
        independent: true,
        commonNames: `Japan, Nihon, Nippon`
    },
    {
        countryName: "Jersey",
        alpha2Code: "JE",
        alpha3Code: "JEY",
        numericCode: 832.0,
        iso3166Link: "ISO 3166-2:JE",
        independent: false,
        commonNames: `Jersey, Channel Islands, Bailiwick of Jersey`
    },
    {
        countryName: "Jordan",
        alpha2Code: "JO",
        alpha3Code: "JOR",
        numericCode: 400.0,
        iso3166Link: "ISO 3166-2:JO",
        independent: true,
        commonNames: `Jordan, Hashemite Kingdom of Jordan, Al-Mamlakah Al-Urduniyah Al-Hashimiyah`
    },
    {
        countryName: "Kazakhstan",
        alpha2Code: "KZ",
        alpha3Code: "KAZ",
        numericCode: 398.0,
        iso3166Link: "ISO 3166-2:KZ",
        independent: true,
        commonNames: `Kazakhstan, Qazaqstan, Republic of Kazakhstan, Казахстан, Республика Казахстан`
    },
    {
        countryName: "Kenya",
        alpha2Code: "KE",
        alpha3Code: "KEN",
        numericCode: 404.0,
        iso3166Link: "ISO 3166-2:KE",
        independent: true,
        commonNames: `Kenya, Republic of Kenya, East Africa, KEN`
    },
    {
        countryName: "Kiribati",
        alpha2Code: "KI",
        alpha3Code: "KIR",
        numericCode: 296.0,
        iso3166Link: "ISO 3166-2:KI",
        independent: true,
        commonNames: `Kiribati, Gilbert Islands`
    },
    {
        countryName: "Korea (Democratic People's Republic of)",
        alpha2Code: "KP",
        alpha3Code: "PRK",
        numericCode: 408.0,
        iso3166Link: "ISO 3166-2:KP",
        independent: true,
        commonNames: `Korea (Democratic People's Republic of), North Korea, DPRK, Democratic People's Republic of Korea`
    },
    {
        countryName: "Korea, Republic of",
        alpha2Code: "KR",
        alpha3Code: "KOR",
        numericCode: 410.0,
        iso3166Link: "ISO 3166-2:KR",
        independent: true,
        commonNames: `South Korea, Republic of Korea, ROK`
    },
    {
        countryName: "Kuwait",
        alpha2Code: "KW",
        alpha3Code: "KWT",
        numericCode: 414.0,
        iso3166Link: "ISO 3166-2:KW",
        independent: true,
        commonNames: `Kuwait, State of Kuwait, Kuwaiti Republic`
    },
    {
        countryName: "Kyrgyzstan",
        alpha2Code: "KG",
        alpha3Code: "KGZ",
        numericCode: 417.0,
        iso3166Link: "ISO 3166-2:KG",
        independent: true,
        commonNames: `Kyrgyzstan, Kirgizstan`
    },
    {
        countryName: "Lao People's Democratic Republic",
        alpha2Code: "LA",
        alpha3Code: "LAO",
        numericCode: 418.0,
        iso3166Link: "ISO 3166-2:LA",
        independent: true,
        commonNames: `Lao People's Democratic Republic, Laos, PDR, Lao, Indochina, Southeast Asia`
    },
    {
        countryName: "Latvia",
        alpha2Code: "LV",
        alpha3Code: "LVA",
        numericCode: 428.0,
        iso3166Link: "ISO 3166-2:LV",
        independent: true,
        commonNames: `Latvia, Lettland`
    },
    {
        countryName: "Lebanon",
        alpha2Code: "LB",
        alpha3Code: "LBN",
        numericCode: 422.0,
        iso3166Link: "ISO 3166-2:LB",
        independent: true,
        commonNames: `Lebanon, The Lebanese Republic`
    },
    {
        countryName: "Lesotho",
        alpha2Code: "LS",
        alpha3Code: "LSO",
        numericCode: 426.0,
        iso3166Link: "ISO 3166-2:LS",
        independent: true,
        commonNames: `Lesotho, Kingdom of Lesotho, Basutoland`
    },
    {
        countryName: "Liberia",
        alpha2Code: "LR",
        alpha3Code: "LBR",
        numericCode: 430.0,
        iso3166Link: "ISO 3166-2:LR",
        independent: true,
        commonNames: `Liberia, The Republic of Liberia, West Africa`
    },
    {
        countryName: "Libya",
        alpha2Code: "LY",
        alpha3Code: "LBY",
        numericCode: 434.0,
        iso3166Link: "ISO 3166-2:LY",
        independent: true,
        commonNames: `Libya, Great Socialist People's Libyan Arab Jamahiriya, State of Libya`
    },
    {
        countryName: "Liechtenstein",
        alpha2Code: "LI",
        alpha3Code: "LIE",
        numericCode: 438.0,
        iso3166Link: "ISO 3166-2:LI",
        independent: true,
        commonNames: `Lichtenstein, LI, Principality of Liechtenstein`
    },
    {
        countryName: "Lithuania",
        alpha2Code: "LT",
        alpha3Code: "LTU",
        numericCode: 440.0,
        iso3166Link: "ISO 3166-2:LT",
        independent: true,
        commonNames: `Lithuania, Lietuva`
    },
    {
        countryName: "Luxembourg",
        alpha2Code: "LU",
        alpha3Code: "LUX",
        numericCode: 442.0,
        iso3166Link: "ISO 3166-2:LU",
        independent: true,
        commonNames: `Luxembourg, Luxemburg`
    },
    {
        countryName: "Macao",
        alpha2Code: "MO",
        alpha3Code: "MAC",
        numericCode: 446.0,
        iso3166Link: "ISO 3166-2:MO",
        independent: false,
        commonNames: `Macao, China, Macau SAR, Aomen, Macau Special Administrative Region`
    },
    {
        countryName: "Madagascar",
        alpha2Code: "MG",
        alpha3Code: "MDG",
        numericCode: 450.0,
        iso3166Link: "ISO 3166-2:MG",
        independent: true,
        commonNames: `Madagascar, The Red Island, The Eighth Continent`
    },
    {
        countryName: "Malawi",
        alpha2Code: "MW",
        alpha3Code: "MWI",
        numericCode: 454.0,
        iso3166Link: "ISO 3166-2:MW",
        independent: true,
        commonNames: `Malawi, Warm Heart of Africa`
    },
    {
        countryName: "Malaysia",
        alpha2Code: "MY",
        alpha3Code: "MYS",
        numericCode: 458.0,
        iso3166Link: "ISO 3166-2:MY",
        independent: true,
        commonNames: `Malaysia, Malay Peninsula, Borneo Peninsula, Federation of Malaya`
    },
    {
        countryName: "Maldives",
        alpha2Code: "MV",
        alpha3Code: "MDV",
        numericCode: 462.0,
        iso3166Link: "ISO 3166-2:MV",
        independent: true,
        commonNames: `Maldives, Maldive Islands, Republic of Maldives`
    },
    {
        countryName: "Mali",
        alpha2Code: "ML",
        alpha3Code: "MLI",
        numericCode: 466.0,
        iso3166Link: "ISO 3166-2:ML",
        independent: true,
        commonNames: `Mali, Republic of Mali, French Sudan`
    },
    {
        countryName: "Malta",
        alpha2Code: "MT",
        alpha3Code: "MLT",
        numericCode: 470.0,
        iso3166Link: "ISO 3166-2:MT",
        independent: true,
        commonNames: `Malta, The Republic of Malta, The Maltese Islands, The Order of St. John`
    },
    {
        countryName: "Marshall Islands",
        alpha2Code: "MH",
        alpha3Code: "MHL",
        numericCode: 584.0,
        iso3166Link: "ISO 3166-2:MH",
        independent: true,
        commonNames: `Marshall Islands, Micronesia, RMI`
    },
    {
        countryName: "Martinique",
        alpha2Code: "MQ",
        alpha3Code: "MTQ",
        numericCode: 474.0,
        iso3166Link: "ISO 3166-2:MQ",
        independent: false,
        commonNames: `Martinique, Madinina`
    },
    {
        countryName: "Mauritania",
        alpha2Code: "MR",
        alpha3Code: "MRT",
        numericCode: 478.0,
        iso3166Link: "ISO 3166-2:MR",
        independent: true,
        commonNames: `Mauritania, Islamic Republic of Mauritania`
    },
    {
        countryName: "Mauritius",
        alpha2Code: "MU",
        alpha3Code: "MUS",
        numericCode: 480.0,
        iso3166Link: "ISO 3166-2:MU",
        independent: true,
        commonNames: `Mauritius, Republic of Mauritius`
    },
    {
        countryName: "Mayotte",
        alpha2Code: "YT",
        alpha3Code: "MYT",
        numericCode: 175.0,
        iso3166Link: "ISO 3166-2:YT",
        independent: false,
        commonNames: `Mayotte, Mahore, Maore, Department of Mayotte`
    },
    {
        countryName: "Mexico",
        alpha2Code: "MX",
        alpha3Code: "MEX",
        numericCode: 484.0,
        iso3166Link: "ISO 3166-2:MX",
        independent: true,
        commonNames: `Mexico, United Mexican States, Estados Unidos Mexicanos`
    },
    {
        countryName: "Micronesia (Federated States of)",
        alpha2Code: "FM",
        alpha3Code: "FSM",
        numericCode: 583.0,
        iso3166Link: "ISO 3166-2:FM",
        independent: true,
        commonNames: `Micronesia (Federated States of), Micronesia, FSM`
    },
    {
        countryName: "Moldova, Republic of",
        alpha2Code: "MD",
        alpha3Code: "MDA",
        numericCode: 498.0,
        iso3166Link: "ISO 3166-2:MD",
        independent: true,
        commonNames: `Moldova, Republic of, Moldova, Moldavia`
    },
    {
        countryName: "Monaco",
        alpha2Code: "MC",
        alpha3Code: "MCO",
        numericCode: 492.0,
        iso3166Link: "ISO 3166-2:MC",
        independent: true,
        commonNames: `Monaco, City-state, Principality of Monaco`
    },
    {
        countryName: "Mongolia",
        alpha2Code: "MN",
        alpha3Code: "MNG",
        numericCode: 496.0,
        iso3166Link: "ISO 3166-2:MN",
        independent: true,
        commonNames: `Mongolia, Outer Mongolia`
    },
    {
        countryName: "Montenegro",
        alpha2Code: "ME",
        alpha3Code: "MNE",
        numericCode: 499.0,
        iso3166Link: "ISO 3166-2:ME",
        independent: true,
        commonNames: `Montenegro, Crna Gora`
    },
    {
        countryName: "Montserrat",
        alpha2Code: "MS",
        alpha3Code: "MSR",
        numericCode: 500.0,
        iso3166Link: "ISO 3166-2:MS",
        independent: false,
        commonNames: `Montserrat, Little England`
    },
    {
        countryName: "Morocco",
        alpha2Code: "MA",
        alpha3Code: "MAR",
        numericCode: 504.0,
        iso3166Link: "ISO 3166-2:MA",
        independent: true,
        commonNames: `Morocco, The Kingdom of Morocco, Al-Magrib, The Western Kingdom`
    },
    {
        countryName: "Mozambique",
        alpha2Code: "MZ",
        alpha3Code: "MOZ",
        numericCode: 508.0,
        iso3166Link: "ISO 3166-2:MZ",
        independent: true,
        commonNames: `Mozambique, Republic of Mozambique`
    },
    {
        countryName: "Myanmar",
        alpha2Code: "MM",
        alpha3Code: "MMR",
        numericCode: 104.0,
        iso3166Link: "ISO 3166-2:MM",
        independent: true,
        commonNames: `Burma, Burma, The Union of Myanmar`
    },
    {
        countryName: "Namibia",
        alpha2Code: "nan",
        alpha3Code: "NAM",
        numericCode: 516.0,
        iso3166Link: "ISO 3166-2:NA",
        independent: true,
        commonNames: `Namibia, Southwest Africa, South West Africa`
    },
    {
        countryName: "Nauru",
        alpha2Code: "NR",
        alpha3Code: "NRU",
        numericCode: 520.0,
        iso3166Link: "ISO 3166-2:NR",
        independent: true,
        commonNames: `Nauru, Pleasant Island`
    },
    {
        countryName: "Nepal",
        alpha2Code: "NP",
        alpha3Code: "NPL",
        numericCode: 524.0,
        iso3166Link: "ISO 3166-2:NP",
        independent: true,
        commonNames: `Nepal, The Federal Democratic Republic of Nepal, The Roof of the World, The Land of Everest`
    },
    {
        countryName: "Netherlands, Kingdom of the",
        alpha2Code: "NL",
        alpha3Code: "NLD",
        numericCode: 528.0,
        iso3166Link: "ISO 3166-2:NL",
        independent: true,
        commonNames: `Netherlands, Kingdom of the, Netherlands, Holland`
    },
    {
        countryName: "New Caledonia",
        alpha2Code: "NC",
        alpha3Code: "NCL",
        numericCode: 540.0,
        iso3166Link: "ISO 3166-2:NC",
        independent: false,
        commonNames: `New Caledonia, NC, Kanaky`
    },
    {
        countryName: "New Zealand",
        alpha2Code: "NZ",
        alpha3Code: "NZL",
        numericCode: 554.0,
        iso3166Link: "ISO 3166-2:NZ",
        independent: true,
        commonNames: `New Zealand`
    },
    {
        countryName: "Nicaragua",
        alpha2Code: "NI",
        alpha3Code: "NIC",
        numericCode: 558.0,
        iso3166Link: "ISO 3166-2:NI",
        independent: true,
        commonNames: `Nicaragua, Nicaragua, Republic of Nicaragua, República de Nicaragua, Nicaragua, República de Nicaragua`
    },
    {
        countryName: "Niger",
        alpha2Code: "NE",
        alpha3Code: "NER",
        numericCode: 562.0,
        iso3166Link: "ISO 3166-2:NE",
        independent: true,
        commonNames: `Niger, Republic of Niger`
    },
    {
        countryName: "Nigeria",
        alpha2Code: "NG",
        alpha3Code: "NGA",
        numericCode: 566.0,
        iso3166Link: "ISO 3166-2:NG",
        independent: true,
        commonNames: `Naija, Giant of Africa, Federal Republic of Nigeria, West African powerhouse`
    },
    {
        countryName: "Niue",
        alpha2Code: "NU",
        alpha3Code: "NIU",
        numericCode: 570.0,
        iso3166Link: "ISO 3166-2:NU",
        independent: false,
        commonNames: `Niue`
    },
    {
        countryName: "Norfolk Island",
        alpha2Code: "NF",
        alpha3Code: "NFK",
        numericCode: 574.0,
        iso3166Link: "ISO 3166-2:NF",
        independent: false,
        commonNames: `Norfolk Island, Territory of Norfolk Island, Territory of the Norfolk Island`
    },
    {
        countryName: "North Macedonia",
        alpha2Code: "MK",
        alpha3Code: "MKD",
        numericCode: 807.0,
        iso3166Link: "ISO 3166-2:MK",
        independent: true,
        commonNames: `North Macedonia, Macedonia, FYROM, Former Yugoslav Republic of Macedonia`
    },
    {
        countryName: "Northern Mariana Islands",
        alpha2Code: "MP",
        alpha3Code: "MNP",
        numericCode: 580.0,
        iso3166Link: "ISO 3166-2:MP",
        independent: false,
        commonNames: `Commonwealth of the Northern Mariana Islands, CNMI`
    },
    {
        countryName: "Norway",
        alpha2Code: "NO",
        alpha3Code: "NOR",
        numericCode: 578.0,
        iso3166Link: "ISO 3166-2:NO",
        independent: true,
        commonNames: `Norway, Norge, Noreg`
    },
    {
        countryName: "Oman",
        alpha2Code: "OM",
        alpha3Code: "OMN",
        numericCode: 512.0,
        iso3166Link: "ISO 3166-2:OM",
        independent: true,
        commonNames: `Oman, Sultanate of Oman`
    },
    {
        countryName: "Pakistan",
        alpha2Code: "PK",
        alpha3Code: "PAK",
        numericCode: 586.0,
        iso3166Link: "ISO 3166-2:PK",
        independent: true,
        commonNames: `Pakistan, Islamic Republic of Pakistan`
    },
    {
        countryName: "Palau",
        alpha2Code: "PW",
        alpha3Code: "PLW",
        numericCode: 585.0,
        iso3166Link: "ISO 3166-2:PW",
        independent: true,
        commonNames: `Palau, Belau, Pelew, Belau, Republic of Palau`
    },
    {
        countryName: "Palestine, State of",
        alpha2Code: "PS",
        alpha3Code: "PSE",
        numericCode: 275.0,
        iso3166Link: "ISO 3166-2:PS",
        independent: false,
        commonNames: `Palestine, State of, "Israel, West Bank, Gaza Strip"`
    },
    {
        countryName: "Panama",
        alpha2Code: "PA",
        alpha3Code: "PAN",
        numericCode: 591.0,
        iso3166Link: "ISO 3166-2:PA",
        independent: true,
        commonNames: `Panama,Republic of Panama,PTY`
    },
    {
        countryName: "Papua New Guinea",
        alpha2Code: "PG",
        alpha3Code: "PNG",
        numericCode: 598.0,
        iso3166Link: "ISO 3166-2:PG",
        independent: true,
        commonNames: `Papua New Guinea, PNG`
    },
    {
        countryName: "Paraguay",
        alpha2Code: "PY",
        alpha3Code: "PRY",
        numericCode: 600.0,
        iso3166Link: "ISO 3166-2:PY",
        independent: true,
        commonNames: `Paraguay,Republic of Paraguay,The Paraguayan Republic,The Republic of Paraguay`
    },
    {
        countryName: "Peru",
        alpha2Code: "PE",
        alpha3Code: "PER",
        numericCode: 604.0,
        iso3166Link: "ISO 3166-2:PE",
        independent: true,
        commonNames: `Peru, Republic of Peru`
    },
    {
        countryName: "Philippines",
        alpha2Code: "PH",
        alpha3Code: "PHL",
        numericCode: 608.0,
        iso3166Link: "ISO 3166-2:PH",
        independent: true,
        commonNames: `Philippines, RP, Pinas`
    },
    {
        countryName: "Pitcairn",
        alpha2Code: "PN",
        alpha3Code: "PCN",
        numericCode: 612.0,
        iso3166Link: "ISO 3166-2:PN",
        independent: false,
        commonNames: `Pitcairn Islands, Pitcairn`
    },
    {
        countryName: "Poland",
        alpha2Code: "PL",
        alpha3Code: "POL",
        numericCode: 616.0,
        iso3166Link: "ISO 3166-2:PL",
        independent: true,
        commonNames: `Poland, Republic of Poland, Polska, Rzeczpospolita Polska`
    },
    {
        countryName: "Portugal",
        alpha2Code: "PT",
        alpha3Code: "PRT",
        numericCode: 620.0,
        iso3166Link: "ISO 3166-2:PT",
        independent: true,
        commonNames: `Portugal,Portuguese Republic,República Portuguesa`
    },
    {
        countryName: "Puerto Rico",
        alpha2Code: "PR",
        alpha3Code: "PRI",
        numericCode: 630.0,
        iso3166Link: "ISO 3166-2:PR",
        independent: false,
        commonNames: `Puerto Rico, PR, Commonwealth of Puerto Rico`
    },
    {
        countryName: "Qatar",
        alpha2Code: "QA",
        alpha3Code: "QAT",
        numericCode: 634.0,
        iso3166Link: "ISO 3166-2:QA",
        independent: true,
        commonNames: `Qatar,The State of Qatar,State of Qatar`
    },
    {
        countryName: "Réunion",
        alpha2Code: "RE",
        alpha3Code: "REU",
        numericCode: 638.0,
        iso3166Link: "ISO 3166-2:RE",
        independent: false,
        commonNames: `Reunion, La Réunion`
    },
    {
        countryName: "Romania",
        alpha2Code: "RO",
        alpha3Code: "ROU",
        numericCode: 642.0,
        iso3166Link: "ISO 3166-2:RO",
        independent: true,
        commonNames: `Romania, Rumania, Roumania`
    },
    {
        countryName: "Russian Federation",
        alpha2Code: "RU",
        alpha3Code: "RUS",
        numericCode: 643.0,
        iso3166Link: "ISO 3166-2:RU",
        independent: true,
        commonNames: `Russian Federation, Russia, RU, Russian, Russian Republic`
    },
    {
        countryName: "Rwanda",
        alpha2Code: "RW",
        alpha3Code: "RWA",
        numericCode: 646.0,
        iso3166Link: "ISO 3166-2:RW",
        independent: true,
        commonNames: `Rwanda, The Land of a Thousand Hills, The Land of Eternal Spring, The Switzerland of Africa`
    },
    {
        countryName: "Saint Barthélemy",
        alpha2Code: "BL",
        alpha3Code: "BLM",
        numericCode: 652.0,
        iso3166Link: "ISO 3166-2:BL",
        independent: false,
        commonNames: `Saint Barthélemy, St. Barts, St. Barths, St. Barthelemy, Saint Bartelemy`
    },
    {
        countryName: "Saint Helena, Ascension and Tristan da Cunha",
        alpha2Code: "SH",
        alpha3Code: "SHN",
        numericCode: 654.0,
        iso3166Link: "ISO 3166-2:SH",
        independent: false,
        commonNames: `Saint Helena, Ascension and Tristan da Cunha, St. Helena, Ascension, Tristan da Cunha`
    },
    {
        countryName: "Saint Kitts and Nevis",
        alpha2Code: "KN",
        alpha3Code: "KNA",
        numericCode: 659.0,
        iso3166Link: "ISO 3166-2:KN",
        independent: true,
        commonNames: `Saint Kitts and Nevis, St. Kitts and Nevis, Nevis and Saint Kitts, Saint Christopher and Nevis`
    },
    {
        countryName: "Saint Lucia",
        alpha2Code: "LC",
        alpha3Code: "LCA",
        numericCode: 662.0,
        iso3166Link: "ISO 3166-2:LC",
        independent: true,
        commonNames: `Saint Lucia, St. Lucia, Helen of the West, Helen of the West Indies, Helen,`
    },
    {
        countryName: "Saint Martin (French part)",
        alpha2Code: "MF",
        alpha3Code: "MAF",
        numericCode: 663.0,
        iso3166Link: "ISO 3166-2:MF",
        independent: false,
        commonNames: `Saint Martin (French part), St. Martin, St. Martin (French part), French Saint Martin`
    },
    {
        countryName: "Saint Pierre and Miquelon",
        alpha2Code: "PM",
        alpha3Code: "SPM",
        numericCode: 666.0,
        iso3166Link: "ISO 3166-2:PM",
        independent: false,
        commonNames: `Saint Pierre and Miquelon, St. Pierre and Miquelon, St. Pierre, Miquelon`
    },
    {
        countryName: "Saint Vincent and the Grenadines",
        alpha2Code: "VC",
        alpha3Code: "VCT",
        numericCode: 670.0,
        iso3166Link: "ISO 3166-2:VC",
        independent: true,
        commonNames: `Saint Vincent and the Grenadines, St. Vincent, SVG`
    },
    {
        countryName: "Samoa",
        alpha2Code: "WS",
        alpha3Code: "WSM",
        numericCode: 882.0,
        iso3166Link: "ISO 3166-2:WS",
        independent: true,
        commonNames: `"Independent State of Samoa, Western Samoa"`
    },
    {
        countryName: "San Marino",
        alpha2Code: "SM",
        alpha3Code: "SMR",
        numericCode: 674.0,
        iso3166Link: "ISO 3166-2:SM",
        independent: true,
        commonNames: `San Marino, Republic of San Marino`
    },
    {
        countryName: "Sao Tome and Principe",
        alpha2Code: "ST",
        alpha3Code: "STP",
        numericCode: 678.0,
        iso3166Link: "ISO 3166-2:ST",
        independent: true,
        commonNames: `Sao Tome and Principe, STP, Democratic Republic of Sao Tome and Principe`
    },
    {
        countryName: "Saudi Arabia",
        alpha2Code: "SA",
        alpha3Code: "SAU",
        numericCode: 682.0,
        iso3166Link: "ISO 3166-2:SA",
        independent: true,
        commonNames: `Saudi Arabia, KSA, Kingdom of Saudi Arabia`
    },
    {
        countryName: "Senegal",
        alpha2Code: "SN",
        alpha3Code: "SEN",
        numericCode: 686.0,
        iso3166Link: "ISO 3166-2:SN",
        independent: true,
        commonNames: `Senegal,Republic of Senegal`
    },
    {
        countryName: "Serbia",
        alpha2Code: "RS",
        alpha3Code: "SRB",
        numericCode: 688.0,
        iso3166Link: "ISO 3166-2:RS",
        independent: true,
        commonNames: `Serbia, Srbija`
    },
    {
        countryName: "Seychelles",
        alpha2Code: "SC",
        alpha3Code: "SYC",
        numericCode: 690.0,
        iso3166Link: "ISO 3166-2:SC",
        independent: true,
        commonNames: `Seychelles, Republic of Seychelles, Sesel, Repiblik Sesel`
    },
    {
        countryName: "Sierra Leone",
        alpha2Code: "SL",
        alpha3Code: "SLE",
        numericCode: 694.0,
        iso3166Link: "ISO 3166-2:SL",
        independent: true,
        commonNames: `Sierra Leone, Leone, Salone`
    },
    {
        countryName: "Singapore",
        alpha2Code: "SG",
        alpha3Code: "SGP",
        numericCode: 702.0,
        iso3166Link: "ISO 3166-2:SG",
        independent: true,
        commonNames: `Singapore, Republic of Singapore, Lion City`
    },
    {
        countryName: "Sint Maarten (Dutch part)",
        alpha2Code: "SX",
        alpha3Code: "SXM",
        numericCode: 534.0,
        iso3166Link: "ISO 3166-2:SX",
        independent: false,
        commonNames: `Sint Maarten (Dutch part), Sint Maarten, Saint Martin, Dutch Sint Maarten, Dutch part of Saint Martin`
    },
    {
        countryName: "Slovakia",
        alpha2Code: "SK",
        alpha3Code: "SVK",
        numericCode: 703.0,
        iso3166Link: "ISO 3166-2:SK",
        independent: true,
        commonNames: `Slovakia, Slovak Republic`
    },
    {
        countryName: "Slovenia",
        alpha2Code: "SI",
        alpha3Code: "SVN",
        numericCode: 705.0,
        iso3166Link: "ISO 3166-2:SI",
        independent: true,
        commonNames: `Slovenia, Republic of Slovenia`
    },
    {
        countryName: "Solomon Islands",
        alpha2Code: "SB",
        alpha3Code: "SLB",
        numericCode: 90.0,
        iso3166Link: "ISO 3166-2:SB",
        independent: true,
        commonNames: `Solomon Islands, Solomons`
    },
    {
        countryName: "Somalia",
        alpha2Code: "SO",
        alpha3Code: "SOM",
        numericCode: 706.0,
        iso3166Link: "ISO 3166-2:SO",
        independent: true,
        commonNames: `Somalia, Somali Republic, Horn of Africa`
    },
    {
        countryName: "South Africa",
        alpha2Code: "ZA",
        alpha3Code: "ZAF",
        numericCode: 710.0,
        iso3166Link: "ISO 3166-2:ZA",
        independent: true,
        commonNames: `South Africa, RSA, SA`
    },
    {
        countryName: "South Georgia and the South Sandwich Islands",
        alpha2Code: "GS",
        alpha3Code: "SGS",
        numericCode: 239.0,
        iso3166Link: "ISO 3166-2:GS",
        independent: false,
        commonNames: `South Georgia and the South Sandwich Islands, S. Georgia and S. Sandwich Is.`
    },
    {
        countryName: "South Sudan",
        alpha2Code: "SS",
        alpha3Code: "SSD",
        numericCode: 728.0,
        iso3166Link: "ISO 3166-2:SS",
        independent: true,
        commonNames: `South Sudan, S. Sudan, Republic of South Sudan`
    },
    {
        countryName: "Spain",
        alpha2Code: "ES",
        alpha3Code: "ESP",
        numericCode: 724.0,
        iso3166Link: "ISO 3166-2:ES",
        independent: true,
        commonNames: `Spain, Kingdom of Spain`
    },
    {
        countryName: "Sri Lanka",
        alpha2Code: "LK",
        alpha3Code: "LKA",
        numericCode: 144.0,
        iso3166Link: "ISO 3166-2:LK",
        independent: true,
        commonNames: `Sri Lanka`
    },
    {
        countryName: "Sudan",
        alpha2Code: "SD",
        alpha3Code: "SDN",
        numericCode: 729.0,
        iso3166Link: "ISO 3166-2:SD",
        independent: true,
        commonNames: `Sudan,Republic of the Sudan, North Sudan, South Sudan`
    },
    {
        countryName: "Suriname",
        alpha2Code: "SR",
        alpha3Code: "SUR",
        numericCode: 740.0,
        iso3166Link: "ISO 3166-2:SR",
        independent: true,
        commonNames: `Suriname`
    },
    {
        countryName: "Svalbard and Jan Mayen",
        alpha2Code: "SJ",
        alpha3Code: "SJM",
        numericCode: 744.0,
        iso3166Link: "ISO 3166-2:SJ",
        independent: false,
        commonNames: `Svalbard and Jan Mayen, Norway`
    },
    {
        countryName: "Sweden",
        alpha2Code: "SE",
        alpha3Code: "SWE",
        numericCode: 752.0,
        iso3166Link: "ISO 3166-2:SE",
        independent: true,
        commonNames: `Sweden, Sverige`
    },
    {
        countryName: "Switzerland",
        alpha2Code: "CH",
        alpha3Code: "CHE",
        numericCode: 756.0,
        iso3166Link: "ISO 3166-2:CH",
        independent: true,
        commonNames: `Switzerland, Swiss Confederation, Helvetia`
    },
    {
        countryName: "Syrian Arab Republic",
        alpha2Code: "SY",
        alpha3Code: "SYR",
        numericCode: 760.0,
        iso3166Link: "ISO 3166-2:SY",
        independent: true,
        commonNames: `Syrian Arab Republic, Syria, Syria, S.A.R.`
    },
    {
        countryName: "Taiwan, Province of China",
        alpha2Code: "TW",
        alpha3Code: "TWN",
        numericCode: 158.0,
        iso3166Link: "ISO 3166-2:TW",
        independent: false,
        commonNames: `Taiwan, Province of China, Taiwan, Republic of China`
    },
    {
        countryName: "Tajikistan",
        alpha2Code: "TJ",
        alpha3Code: "TJK",
        numericCode: 762.0,
        iso3166Link: "ISO 3166-2:TJ",
        independent: true,
        commonNames: `Tajikistan, Republic of Tajikistan, Tajik Soviet Socialist Republic`
    },
    {
        countryName: "Tanzania, United Republic of",
        alpha2Code: "TZ",
        alpha3Code: "TZA",
        numericCode: 834.0,
        iso3166Link: "ISO 3166-2:TZ",
        independent: true,
        commonNames: `Tanzania, United Republic of, Tanzania, Tanzania Republic`
    },
    {
        countryName: "Thailand",
        alpha2Code: "TH",
        alpha3Code: "THA",
        numericCode: 764.0,
        iso3166Link: "ISO 3166-2:TH",
        independent: true,
        commonNames: `Thailand, Siam`
    },
    {
        countryName: "Timor-Leste",
        alpha2Code: "TL",
        alpha3Code: "TLS",
        numericCode: 626.0,
        iso3166Link: "ISO 3166-2:TL",
        independent: true,
        commonNames: `East Timor, Democratic Republic of Timor-Leste, Timor Lorosa'e`
    },
    {
        countryName: "Togo",
        alpha2Code: "TG",
        alpha3Code: "TGO",
        numericCode: 768.0,
        iso3166Link: "ISO 3166-2:TG",
        independent: true,
        commonNames: `Togo, tog, Togolese Republic`
    },
    {
        countryName: "Tokelau",
        alpha2Code: "TK",
        alpha3Code: "TKL",
        numericCode: 772.0,
        iso3166Link: "ISO 3166-2:TK",
        independent: false,
        commonNames: `Tokelau`
    },
    {
        countryName: "Tonga",
        alpha2Code: "TO",
        alpha3Code: "TON",
        numericCode: 776.0,
        iso3166Link: "ISO 3166-2:TO",
        independent: true,
        commonNames: `Tonga, Friendly Islands`
    },
    {
        countryName: "Trinidad and Tobago",
        alpha2Code: "TT",
        alpha3Code: "TTO",
        numericCode: 780.0,
        iso3166Link: "ISO 3166-2:TT",
        independent: true,
        commonNames: `Trinidad and Tobago, Trinidad, Tobago`
    },
    {
        countryName: "Tunisia",
        alpha2Code: "TN",
        alpha3Code: "TUN",
        numericCode: 788.0,
        iso3166Link: "ISO 3166-2:TN",
        independent: true,
        commonNames: `Tunisia, Tunis, Carthage`
    },
    {
        countryName: "Türkiye",
        alpha2Code: "TR",
        alpha3Code: "TUR",
        numericCode: 792.0,
        iso3166Link: "ISO 3166-2:TR",
        independent: true,
        commonNames: `Türkiye, Turkey`
    },
    {
        countryName: "Turkmenistan",
        alpha2Code: "TM",
        alpha3Code: "TKM",
        numericCode: 795.0,
        iso3166Link: "ISO 3166-2:TM",
        independent: true,
        commonNames: `Turkmenistan, Turkmenia, Turkmania`
    },
    {
        countryName: "Turks and Caicos Islands",
        alpha2Code: "TC",
        alpha3Code: "TCA",
        numericCode: 796.0,
        iso3166Link: "ISO 3166-2:TC",
        independent: false,
        commonNames: `Turks and Caicos Islands, TCI, T&C`
    },
    {
        countryName: "Tuvalu",
        alpha2Code: "TV",
        alpha3Code: "TUV",
        numericCode: 798.0,
        iso3166Link: "ISO 3166-2:TV",
        independent: true,
        commonNames: `Tuvalu, Ellice Islands`
    },
    {
        countryName: "Uganda",
        alpha2Code: "UG",
        alpha3Code: "UGA",
        numericCode: 800.0,
        iso3166Link: "ISO 3166-2:UG",
        independent: true,
        commonNames: `Uganda, The Pearl of Africa`
    },
    {
        countryName: "Ukraine",
        alpha2Code: "UA",
        alpha3Code: "UKR",
        numericCode: 804.0,
        iso3166Link: "ISO 3166-2:UA",
        independent: true,
        commonNames: `Ukraine, The Ukraine, Ukrayina`
    },
    {
        countryName: "United Arab Emirates",
        alpha2Code: "AE",
        alpha3Code: "ARE",
        numericCode: 784.0,
        iso3166Link: "ISO 3166-2:AE",
        independent: true,
        commonNames: `United Arab Emirates, UAE, Emirates, Emirates of Arabia, Emirates of the Gulf, Gulf States`
    },
    {
        countryName: "United Kingdom of Great Britain and Northern Ireland",
        alpha2Code: "GB",
        alpha3Code: "GBR",
        numericCode: 826.0,
        iso3166Link: "ISO 3166-2:GB",
        independent: true,
        commonNames: `United Kingdom, United Kingdom of Great Britain and Northern Ireland, UK, GB, Britain, Great Britain`
    },
    {
        countryName: "United States of America",
        alpha2Code: "US",
        alpha3Code: "USA",
        numericCode: 840.0,
        iso3166Link: "ISO 3166-2:US",
        independent: true,
        commonNames: `United States of America, USA, America, United States, US`
    },
    {
        countryName: "United States Minor Outlying Islands",
        alpha2Code: "UM",
        alpha3Code: "UMI",
        numericCode: 581.0,
        iso3166Link: "ISO 3166-2:UM",
        independent: false,
        commonNames: `United States Minor Outlying Islands, United States Minor Outlying Islands, U.S. Minor Outlying Islands, Minor Outlying Islands, US Minor Outlying Islands`
    },
    {
        countryName: "Uruguay",
        alpha2Code: "UY",
        alpha3Code: "URY",
        numericCode: 858.0,
        iso3166Link: "ISO 3166-2:UY",
        independent: true,
        commonNames: `Uruguay, Oriental Republic of Uruguay`
    },
    {
        countryName: "Uzbekistan",
        alpha2Code: "UZ",
        alpha3Code: "UZB",
        numericCode: 860.0,
        iso3166Link: "ISO 3166-2:UZ",
        independent: true,
        commonNames: `Uzbekistan, Republic of Uzbekistan, UZ, Uzb, Central Asian Country`
    },
    {
        countryName: "Vanuatu",
        alpha2Code: "VU",
        alpha3Code: "VUT",
        numericCode: 548.0,
        iso3166Link: "ISO 3166-2:VU",
        independent: true,
        commonNames: `Vanuatu, Republic of Vanuatu`
    },
    {
        countryName: "Venezuela (Bolivarian Republic of)",
        alpha2Code: "VE",
        alpha3Code: "VEN",
        numericCode: 862.0,
        iso3166Link: "ISO 3166-2:VE",
        independent: true,
        commonNames: `Venezuela (Bolivarian Republic of), Venezuela, Bolivarian Republic of,`
    },
    {
        countryName: "Viet Nam",
        alpha2Code: "VN",
        alpha3Code: "VNM",
        numericCode: 704.0,
        iso3166Link: "ISO 3166-2:VN",
        independent: true,
        commonNames: `Viet Nam, Vietnam, Socialist Republic of Vietnam, Indochina`
    },
    {
        countryName: "Virgin Islands (British)",
        alpha2Code: "VG",
        alpha3Code: "VGB",
        numericCode: 92.0,
        iso3166Link: "ISO 3166-2:VG",
        independent: false,
        commonNames: `Virgin Islands (British), British Virgin Islands, BVI`
    },
    {
        countryName: "Virgin Islands (U.S.)",
        alpha2Code: "VI",
        alpha3Code: "VIR",
        numericCode: 850.0,
        iso3166Link: "ISO 3166-2:VI",
        independent: false,
        commonNames: `Virgin Islands (U.S.), United States Virgin Islands, US Virgin Islands`
    },
    {
        countryName: "Wallis and Futuna",
        alpha2Code: "WF",
        alpha3Code: "WLF",
        numericCode: 876.0,
        iso3166Link: "ISO 3166-2:WF",
        independent: false,
        commonNames: `Wallis and Futuna, French Pacific Territories, Collectivity of Wallis and Futuna`
    },
    {
        countryName: "Western Sahara",
        alpha2Code: "EH",
        alpha3Code: "ESH",
        numericCode: 732.0,
        iso3166Link: "ISO 3166-2:EH",
        independent: false,
        commonNames: `Western Sahara, Western Sahara, Sahrawi Arab Democratic Republic, Sahrawi Republic`
    },
    {
        countryName: "Yemen",
        alpha2Code: "YE",
        alpha3Code: "YEM",
        numericCode: 887.0,
        iso3166Link: "ISO 3166-2:YE",
        independent: true,
        commonNames: `Yemen, Republic of Yemen, Yemeni Republic`
    },
    {
        countryName: "Zambia",
        alpha2Code: "ZM",
        alpha3Code: "ZMB",
        numericCode: 894.0,
        iso3166Link: "ISO 3166-2:ZM",
        independent: true,
        commonNames: `Zambia, The Republic of Zambia, Northern Rhodesia`
    },
    {
        countryName: "Zimbabwe",
        alpha2Code: "ZW",
        alpha3Code: "ZWE",
        numericCode: 716.0,
        iso3166Link: "ISO 3166-2:ZW",
        independent: true,
        commonNames: `Zimbabwe, Rhodesia`
    }
]

export type CountryCode =
    | "AF"
    | "AX"
    | "AL"
    | "DZ"
    | "AS"
    | "AD"
    | "AO"
    | "AI"
    | "AQ"
    | "AG"
    | "AR"
    | "AM"
    | "AW"
    | "AU"
    | "AT"
    | "AZ"
    | "BS"
    | "BH"
    | "BD"
    | "BB"
    | "BY"
    | "BE"
    | "BZ"
    | "BJ"
    | "BM"
    | "BT"
    | "BO"
    | "BQ"
    | "BA"
    | "BW"
    | "BV"
    | "BR"
    | "IO"
    | "BN"
    | "BG"
    | "BF"
    | "BI"
    | "CV"
    | "KH"
    | "CM"
    | "CA"
    | "KY"
    | "CF"
    | "TD"
    | "CL"
    | "CN"
    | "CX"
    | "CC"
    | "CO"
    | "KM"
    | "CG"
    | "CD"
    | "CK"
    | "CR"
    | "CI"
    | "HR"
    | "CU"
    | "CW"
    | "CY"
    | "CZ"
    | "DK"
    | "DJ"
    | "DM"
    | "DO"
    | "EC"
    | "EG"
    | "SV"
    | "GQ"
    | "ER"
    | "EE"
    | "SZ"
    | "ET"
    | "FK"
    | "FO"
    | "FJ"
    | "FI"
    | "FR"
    | "GF"
    | "PF"
    | "TF"
    | "GA"
    | "GM"
    | "GE"
    | "DE"
    | "GH"
    | "GI"
    | "GR"
    | "GL"
    | "GD"
    | "GP"
    | "GU"
    | "GT"
    | "GG"
    | "GN"
    | "GW"
    | "GY"
    | "HT"
    | "HM"
    | "VA"
    | "HN"
    | "HK"
    | "HU"
    | "IS"
    | "IN"
    | "ID"
    | "IR"
    | "IQ"
    | "IE"
    | "IM"
    | "IL"
    | "IT"
    | "JM"
    | "JP"
    | "JE"
    | "JO"
    | "KZ"
    | "KE"
    | "KI"
    | "KP"
    | "KR"
    | "KW"
    | "KG"
    | "LA"
    | "LV"
    | "LB"
    | "LS"
    | "LR"
    | "LY"
    | "LI"
    | "LT"
    | "LU"
    | "MO"
    | "MG"
    | "MW"
    | "MY"
    | "MV"
    | "ML"
    | "MT"
    | "MH"
    | "MQ"
    | "MR"
    | "MU"
    | "YT"
    | "MX"
    | "FM"
    | "MD"
    | "MC"
    | "MN"
    | "ME"
    | "MS"
    | "MA"
    | "MZ"
    | "MM"
    | "NR"
    | "NP"
    | "NL"
    | "NC"
    | "NZ"
    | "NI"
    | "NE"
    | "NG"
    | "NU"
    | "NF"
    | "MK"
    | "MP"
    | "NO"
    | "OM"
    | "PK"
    | "PW"
    | "PS"
    | "PA"
    | "PG"
    | "PY"
    | "PE"
    | "PH"
    | "PN"
    | "PL"
    | "PT"
    | "PR"
    | "QA"
    | "RE"
    | "RO"
    | "RU"
    | "RW"
    | "BL"
    | "SH"
    | "KN"
    | "LC"
    | "MF"
    | "PM"
    | "VC"
    | "WS"
    | "SM"
    | "ST"
    | "SA"
    | "SN"
    | "RS"
    | "SC"
    | "SL"
    | "SG"
    | "SX"
    | "SK"
    | "SI"
    | "SB"
    | "SO"
    | "ZA"
    | "GS"
    | "SS"
    | "ES"
    | "LK"
    | "SD"
    | "SR"
    | "SJ"
    | "SE"
    | "CH"
    | "SY"
    | "TW"
    | "TJ"
    | "TZ"
    | "TH"
    | "TL"
    | "TG"
    | "TK"
    | "TO"
    | "TT"
    | "TN"
    | "TR"
    | "TM"
    | "TC"
    | "TV"
    | "UG"
    | "UA"
    | "AE"
    | "GB"
    | "US"
    | "UM"
    | "UY"
    | "UZ"
    | "VU"
    | "VE"
    | "VN"
    | "VG"
    | "VI"
    | "WF"
    | "EH"
    | "YE"
    | "ZM"
    | "ZW"

export const CountryCodeSchema = v.picklist([
    "AF",
    "AX",
    "AL",
    "DZ",
    "AS",
    "AD",
    "AO",
    "AI",
    "AQ",
    "AG",
    "AR",
    "AM",
    "AW",
    "AU",
    "AT",
    "AZ",
    "BS",
    "BH",
    "BD",
    "BB",
    "BY",
    "BE",
    "BZ",
    "BJ",
    "BM",
    "BT",
    "BO",
    "BQ",
    "BA",
    "BW",
    "BV",
    "BR",
    "IO",
    "BN",
    "BG",
    "BF",
    "BI",
    "CV",
    "KH",
    "CM",
    "CA",
    "KY",
    "CF",
    "TD",
    "CL",
    "CN",
    "CX",
    "CC",
    "CO",
    "KM",
    "CG",
    "CD",
    "CK",
    "CR",
    "CI",
    "HR",
    "CU",
    "CW",
    "CY",
    "CZ",
    "DK",
    "DJ",
    "DM",
    "DO",
    "EC",
    "EG",
    "SV",
    "GQ",
    "ER",
    "EE",
    "SZ",
    "ET",
    "FK",
    "FO",
    "FJ",
    "FI",
    "FR",
    "GF",
    "PF",
    "TF",
    "GA",
    "GM",
    "GE",
    "DE",
    "GH",
    "GI",
    "GR",
    "GL",
    "GD",
    "GP",
    "GU",
    "GT",
    "GG",
    "GN",
    "GW",
    "GY",
    "HT",
    "HM",
    "VA",
    "HN",
    "HK",
    "HU",
    "IS",
    "IN",
    "ID",
    "IR",
    "IQ",
    "IE",
    "IM",
    "IL",
    "IT",
    "JM",
    "JP",
    "JE",
    "JO",
    "KZ",
    "KE",
    "KI",
    "KP",
    "KR",
    "KW",
    "KG",
    "LA",
    "LV",
    "LB",
    "LS",
    "LR",
    "LY",
    "LI",
    "LT",
    "LU",
    "MO",
    "MG",
    "MW",
    "MY",
    "MV",
    "ML",
    "MT",
    "MH",
    "MQ",
    "MR",
    "MU",
    "YT",
    "MX",
    "FM",
    "MD",
    "MC",
    "MN",
    "ME",
    "MS",
    "MA",
    "MZ",
    "MM",
    "NR",
    "NP",
    "NL",
    "NC",
    "NZ",
    "NI",
    "NE",
    "NG",
    "NU",
    "NF",
    "MK",
    "MP",
    "NO",
    "OM",
    "PK",
    "PW",
    "PS",
    "PA",
    "PG",
    "PY",
    "PE",
    "PH",
    "PN",
    "PL",
    "PT",
    "PR",
    "QA",
    "RE",
    "RO",
    "RU",
    "RW",
    "BL",
    "SH",
    "KN",
    "LC",
    "MF",
    "PM",
    "VC",
    "WS",
    "SM",
    "ST",
    "SA",
    "SN",
    "RS",
    "SC",
    "SL",
    "SG",
    "SX",
    "SK",
    "SI",
    "SB",
    "SO",
    "ZA",
    "GS",
    "SS",
    "ES",
    "LK",
    "SD",
    "SR",
    "SJ",
    "SE",
    "CH",
    "SY",
    "TW",
    "TJ",
    "TZ",
    "TH",
    "TL",
    "TG",
    "TK",
    "TO",
    "TT",
    "TN",
    "TR",
    "TM",
    "TC",
    "TV",
    "UG",
    "UA",
    "AE",
    "GB",
    "US",
    "UM",
    "UY",
    "UZ",
    "VU",
    "VE",
    "VN",
    "VG",
    "VI",
    "WF",
    "EH",
    "YE",
    "ZM",
    "ZW"
])

export const validateCountryCode = (code: string) => {
    return v.safeParse(CountryCodeSchema, code)
}
